/* global TrackWidget */

import parametro from "../../commons/services/parametro";
import usuario from "../../commons/services/usuario";

export const iniciarPesquisaSatisfacaoWidget = () => {
	(async function (f, b, g) {
		const script = document.getElementById("trackwidget-js");
		if (script) {
			return;
		}

		let npsKey = null;
		let usuarioLogado = null;

		try {
			npsKey = await parametro.getNpsKey();
			usuarioLogado = await usuario.getNomeCdUsuario();
		} catch (e) {
			console.warn("Erro ao buscar parametro ou usuario logado na pesquisa de satisfação");
			return;
		}

		var a = {
			key: npsKey,
			customer: {
				name: usuarioLogado && usuarioLogado.nome ? usuarioLogado.nome : "",
				Identificador: usuarioLogado && usuarioLogado.cdUsuario ? usuarioLogado.cdUsuario.toString() : "",
			}
		};

		var e;
		var c = f.getElementsByTagName(b)[0];
		if (f.getElementById(g)) {
			return
		}
		e = f.createElement(b);
		e.id = g;
		e.src = 'https://app.track.co/widget.min.js';
		e.type = 'text/javascript';
		e.async = true;
		e.onload = e.onreadystatechange = function () {
			var h = this.readyState;
			if (h && h !== 'complete' && h !== 'loaded') {
				return
			}
			;
			try {
				var c = new TrackWidget();
				c.createWidget(a);
			} catch (i) {
			}
		};
		c.parentNode.insertBefore(e, c);
	}(document, 'script', 'trackwidget-js'));
};
